/**
 * Component destination-item-default JS
 *
 * !!! Uncomment only if component is needed, this way the compiler will ignore useless files
 */
jQuery(document).ready(function () {
    const component = jQuery('.destination-item-default');

    if (!component.length) {
        return;
    }


    jQuery('.destination-item-default__mobile-toggle').bind('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const parent = jQuery(this).closest('.destination-item-default__mobile');
        // const info = parent.find('.destination-item-default__mobile-group');
        // const openIcon = jQuery(this).find('.ll-open');
        // const closeIcon = jQuery(this).find('.ll-close');

        parent.toggleClass('is-expanded');
        // info.toggleClass('d-none');
        // openIcon.toggleClass('d-none');
        // closeIcon.toggleClass('d-none');

    });

});